import * as Scrivito from "scrivito"

export const DemandRequestOverlayObjClass = Scrivito.provideObjClass(
  "DemandRequestOverlay",
  {
    attributes: {
      form: "widgetlist"
    }
  }
)

export type DemandRequestOverlayObj = InstanceType<
  typeof DemandRequestOverlayObjClass
>
